const WaLogoMark = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask
      id="wa-footer-mask"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="1"
      width="24"
      height="22"
    >
      <path
        d="M15.3845 3.93215L22.5149 16.5062C24.2188 19.5098 21.1436 22.9402 17.8043 21.7625L13.327 20.1836C12.4702 19.8815 11.5296 19.8815 10.6729 20.1836L6.19553 21.7625C2.85629 22.9402 -0.218514 19.5098 1.48493 16.5062L8.61636 3.93215C10.0773 1.35595 13.9235 1.35595 15.3845 3.93215Z"
        fill="#D9D9D9"
        stroke="black"
      />
    </mask>
    <g mask="url(#wa-footer-mask)">
      <path
        opacity="0.75"
        d="M31.8301 2.62317C36.4887 8.38919 38.4855 19.4373 36.2275 27.5018C33.9994 35.6063 27.4905 40.7273 21.3267 43.6305C15.1936 46.4933 9.37768 47.1384 4.37219 44.2756C-0.633584 41.3724 -4.8579 34.9612 -6.91213 26.6147C-8.99547 18.268 -8.90854 8.02632 -5.29185 2.58284C-1.67506 -2.8606 5.47178 -3.50575 12.6764 -3.58639C19.9091 -3.62671 27.2005 -3.14285 31.8301 2.62317Z"
        fill="url(#wa-footer-grad0)"
      />
      <path
        opacity="0.75"
        d="M19.3607 32.7392C15.1994 33.6412 9.97418 31.6653 7.62948 28.2397C5.2578 24.8174 5.78013 19.9295 7.05608 15.8373C8.33588 11.7717 10.3809 8.48668 13.5129 6.6004C16.6613 4.72509 20.9084 4.23319 25.0735 5.43349C29.2493 6.61847 33.3277 9.48455 34.0803 12.9157C34.833 16.3468 32.2618 20.343 29.4401 24.2148C26.5914 28.0907 23.5094 31.8533 19.3607 32.7392Z"
        fill="url(#wa-footer-grad1)"
      />
      <path
        opacity="0.75"
        d="M46.4553 16.5113C49.0882 19.9961 49.2906 25.6847 46.8427 29.3069C44.4113 32.9531 39.3094 34.5291 34.6904 35.0696C30.0945 35.5948 25.9621 35.0807 22.7732 32.9665C19.5891 30.8324 17.3302 27.094 16.7954 22.7186C16.2412 18.3391 17.4073 13.3423 20.522 11.1958C23.6367 9.04936 28.7 9.75341 33.7421 10.7417C38.8016 11.7541 43.8437 13.0308 46.4553 16.5113Z"
        fill="url(#wa-footer-grad2)"
      />
    </g>
    <defs>
      <linearGradient id="wa-footer-grad0" x1="14.4352" y1="-3.5885" x2="14.4352" y2="46.1272" gradientUnits="userSpaceOnUse">
        <stop offset="0.22" stopColor="#07BA81" />
        <stop offset="1" stopColor="#03543A" />
      </linearGradient>
      <linearGradient id="wa-footer-grad1" x1="20.0939" y1="4.78046" x2="20.0939" y2="32.9571" gradientUnits="userSpaceOnUse">
        <stop stopColor="#BAF3DB" />
        <stop offset="1" stopColor="#2DE095" />
      </linearGradient>
      <linearGradient id="wa-footer-grad2" x1="26" y1="23" x2="1.5" y2="6.5" gradientUnits="userSpaceOnUse">
        <stop offset="0.265" stopColor="#18A979" />
        <stop offset="0.54" stopColor="#197053" />
      </linearGradient>
    </defs>
  </svg>
);

const PRIVACY_POLICY_URL = "https://whereabouts.helpscoutdocs.com/article/144-privacy-policy";

export const TripperFooter = () => {
  return (
    <div className="tripper-attribution">
      <div className="tripper-attribution__brand">
        <WaLogoMark />
        <span>
          Powered by <span style={{ fontWeight: 600 }}>Whereabouts</span>
        </span>
      </div>
      <p className="tripper-attribution__disclaimer">
        Please note that while we endeavour to keep these itineraries up-to-date we cannot
        guarantee the reliability of all information. By using this website you agree to our{" "}
        <a
          href={PRIVACY_POLICY_URL}
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "underline", cursor: "pointer", color: "inherit" }}
        >
          privacy policy
        </a>
        .
      </p>
    </div>
  );
};
